import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import api from '../../Api/api';
import InfoGroup from '../InfoGroup/InfoGroup';
import ProjectNotes from '../ProjectNotes/ProjectNotes';
import TabButtons from '../TabButtons/TabButtons';
import {
  REQUEST_GET_PROJECT_DATA,
  REQUEST_GET_ALL_PROJECTS_FOR_ADMIN,
  CLEAR_CURRENT_PROJECT,
  REQUEST_GET_PROJECT_STATS,
} from '../../Redux/constants/constants';
import { Modal, Collapse } from 'antd';
import ProjectStats from '../ProjectStats/ProjectStats';

const { confirm } = Modal;
const { Panel } = Collapse;

const ProjectOverviewTab = ({ data, isEditing, userView }) => {
  const [editing, setEditing] = useState(isEditing);
  const [loading, setLoading] = useState(false);
  const [localData, setLocalData] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    setLocalData(data);
    if (data.newProject === true) {
      setEditing(true);
    } else {
      setEditing(false);
    }
    dispatch({
      type: REQUEST_GET_PROJECT_STATS,
      payload: data.id,
    });
  }, [data]);

  const handleClick = (value) => {
    if (value === 'save') {
      setLoading(true);
      api
        .postProjectData({
          id: localData.id,
          number: localData.number,
          name: localData.name,
          status: localData.status,
          startDate: localData.startDate,
          endDate: localData.endDate,
          estimatedHours: localData.estimatedHours,
        })
        .then((res) => {
          setEditing(false);
          setLoading(false);
          dispatch({ type: REQUEST_GET_PROJECT_DATA, payload: res.data.id });
          dispatch({ type: REQUEST_GET_ALL_PROJECTS_FOR_ADMIN });
        })
        .catch(() => {
          setEditing(false);
          setLoading(false);
          console.log('some error during save');
        });
    }
    if (value === 'edit') setEditing(true);
    if (value === 'cancel') setEditing(false);
    if (value === 'delete') {
      showConfirm();
    }
  };

  const showConfirm = () => {
    confirm({
      title: 'Czy jesteś pewny, że chcesz skasować projekt?',
      content: `${localData.name}`,
      okType: 'danger',
      okText: 'Usuń',
      cancelText: 'Anuluj',
      onOk() {
        api
          .deleteProject({
            id: localData.id,
          })
          .then((res) => {
            setEditing(false);
            setLoading(false);
            setLocalData({});
            dispatch({ type: CLEAR_CURRENT_PROJECT });
            dispatch({ type: REQUEST_GET_ALL_PROJECTS_FOR_ADMIN });
          })
          .catch(() => {
            setEditing(false);
            setLoading(false);
            console.log('some error during delete');
          });
      },
      onCancel() {},
    });
  };

  const onChange = (value, key) => {
    setLocalData({ ...localData, [key]: value });
  };

  return (
    <>
      <ProjectStats userView={userView} />
      <InfoGroup
        editable
        type={'text'}
        text={'Nazwa projektu'}
        placeHolder={'Nazwa projektu'}
        data={localData.name}
        editing={editing}
        onChange={onChange}
        id={'name'}
      />
      <InfoGroup
        editable
        type={'text'}
        text={'Numer projektu'}
        placeHolder={'Numer projektu'}
        data={localData.number}
        editing={editing}
        onChange={onChange}
        id={'number'}
      />
      {!userView && (
        <InfoGroup
          editable
          type={'status-drop-down'}
          text={'Status'}
          placeHolder={'Status'}
          data={localData.status}
          editing={editing}
          onChange={onChange}
          id={'status'}
        />
      )}
      {!userView && (
        <TabButtons
          editing={editing}
          handleClick={handleClick}
          loading={loading}
          isProjectLoaded={localData.id}
        />
      )}
      <Collapse
        bordered={false}
        style={{ borderRadius: '0', borderBottom: '0' }}
      >
        <Panel
          header="Notatki"
          key="1"
          style={{ borderRadius: '0', borderBottom: '0' }}
        >
          <ProjectNotes
            style={{ marginTop: '1000px' }}
            notes={localData.projectNotes}
            projectId={localData.id}
          />
        </Panel>
      </Collapse>
    </>
  );
};

export default ProjectOverviewTab;
